import IMask from 'imask';

export const PHONE_MASKS = {
  PHONE: '0000-0000',
  PHONE9: '00000-0000',
  PHONE_DDD: '(00) 0000-0000',
  PHONE9_DDD: '(00) 00000-0000',
  PHONE_INT: '+00 (00) 0000-0000',
  PHONE9_INT: '+00 (00) 00000-000',
  PHONE_0800: '0000 000 0000',
};

const MASKS = {
  PHONE: '0000-00000',
  PHONE9: '00000-00000',
  PHONE_DDD: '(00) 0000-00000',
  PHONE9_DDD: '(00) 00000-00000',
  PHONE_INT: '+00 (00) 0000-00000',
  PHONE9_INT: '+00 (00) 00000-0000',
  PHONE_0800: '0000 000 00000',
};

export function getPhoneMask(text: string) {
  const phone = text?.replace(/[^0-9]/gi, '') || '';

  if (phone?.length <= 8) {
    return MASKS.PHONE;
  } else if (phone?.length <= 9) {
    return MASKS.PHONE9;
  } else if (phone?.length <= 10) {
    return MASKS.PHONE_DDD;
  } else if (phone?.length <= 11) {
    if (phone?.startsWith('0800')) {
      return MASKS.PHONE_0800;
    }
    return MASKS.PHONE9_DDD;
  } else if (phone?.length <= 12) {
    return MASKS.PHONE_INT;
  } else {
    return MASKS.PHONE9_INT;
  }
}

export function getTaxPayerMask(text: string) {
  const taxPayer = text?.replace(/[^0-9]/gi, '') || '';

  if (taxPayer?.length <= 11) {
    return '000.000.000-00';
  }
  return '00.000.000/0000-00';
}

export function maskText(text: string, mask: string) {
  return IMask.createMask({
    mask,
  }).resolve(text);
}

export function maskPhone(phone: string) {
  return maskText(phone, getPhoneMask(phone));
}

export function maskTaxPayer(taxPayer: string) {
  return maskText(taxPayer, getTaxPayerMask(taxPayer));
}

export function maskZipCode(zipCode: string) {
  return maskText(zipCode, '00000-000');
}
